import { Delete, PhotoCamera } from '@mui/icons-material'
import { CircularProgress, IconButton, ImageListItem, Stack, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { clearPollOptions, deleteAllOptionImgs, deleteOptionImg, uploadOptionImg } from '../../../redux/actions/pollOptions.action';

const PollOptionsV3 = ({ numOpts, pollDetails, setPollDetails, editDetails, setEditDetails, isEdit, filePreview, setFilePreview, duration }) => {
    const dispatch = useDispatch();
    const { pollOptions, imgSuccess } = useSelector((state) => {
        return {
            pollOptions: state.pollOptionsReducer.pollOptions,
            imgSuccess: state.pollOptionsReducer.imgSuccess,
        };
    });

    // console.log(pollDetails?.options, "pollDetails2")

    //-------------- OPTION INPUT VIEW ---------------//
    const inputField = (optNum, value) => {
        // console.log("OptNum", optNum);
        console.log("Value1", value);
        return (
            <Stack
                key={`poll_option_${optNum}`}
                direction='row'
                alignItems='center'
                spacing={2}>
                <TextField
                    margin='normal'
                    required
                    fullWidth
                    id={!isEdit ? optNum : value?.id}
                    label={`Option ${optNum + 1}`}
                    name={"option"}
                    // pollDetails?.options[optNum]?.option
                    value={
                        !isEdit ?
                            `${pollDetails?.options?.length > 0 ? pollDetails?.options[optNum]?.option : null}`
                            : value?.option
                    }
                    onChange={(e) => handleInputChange(e, optNum)}
                />
                <TextField
                    margin='normal'
                    required
                    fullWidth
                    id={!isEdit ? optNum : value?.id}
                    label={`Order ${optNum + 1}`}
                    name={"order"}
                    type='number'
                    value={
                        !isEdit ?
                            `${pollDetails?.options?.length > 0 ? pollDetails?.options[optNum]?.order : null}`
                            : value?.order
                    }
                    onChange={(e) => handleInputChange(e, optNum)}
                />
                {console.log(pollOptions,"pollOptions")}
                {
                    pollOptions[`${optNum}`]?.loading ? <CircularProgress color="secondary" /> :
                        (pollOptions[`${optNum}`]?.data || value?.image) ? (
                            <div>
                                {
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <ImageListItem key={optNum} sx={{ width: 100, height: 100 }}>
                                            <img
                                                src={pollOptions[`${optNum}`]?.data || value?.image}
                                                alt=''
                                            />
                                        </ImageListItem>
                                        <div style={{ cursor: "pointer" }} onClick={() => handleDeleteImage(optNum)} >
                                            <Delete />
                                        </div>
                                    </div>
                                }
                            </div>
                        ) : (
                            <IconButton
                                color='primary'
                                name={`image`}
                                aria-label='upload picture'
                                component='label'
                                onChange={(e) => handleInputChange(e, optNum)}
                            >
                                <input hidden name={`image`} accept='image/*' type='file' />
                                <PhotoCamera />
                            </IconButton>
                        )
                }
            </Stack>)
    };

    //------------ OPTION INPUT DELETE IMG -----------//
    const handleDeleteImage = (index) => {
        // todo: check if image exist at this index and not loading
        
        if (!isEdit) {
            dispatch(deleteOptionImg({ name: index, link: pollOptions[index]?.data }));
        } else {
            let newArray = [...pollDetails.options];
            newArray[index].image = null;
            newArray[index].order = "";
            newArray[index].option = "";

            setPollDetails({
                ...pollDetails, options: [...newArray]
            })
            if (isEdit) {
                setEditDetails({ ...editDetails, options: newArray });
            }
        }
    };

    //--------- OPTION INPUT NAME or IMG CHNG --------//
    const handleInputChange = (e, index) => {
        const { id, name, value, files } = e.target;
        // option name change
        if (!files) {
            let newArray = [...pollDetails.options];
            newArray[index][name] = value;
            setPollDetails({
                ...pollDetails, options: [...newArray]
            })
            if (newArray[index].id) newArray[index].id = id;
            setEditDetails({
                ...editDetails, options: [...newArray]
            })
        }
        // option img change
        if (files) {
            let newArray = [...pollDetails.options];
            newArray[index].image = files[0];
            let formData = new FormData();
            formData.append('name', `${index}`);
            formData.append('image', files[0]);

            dispatch(uploadOptionImg(formData, index));
            return;
        }
    };

    //--------- SHOW NUMBER OF OPTION INPUT --------//
    const generateInputFields = () => {
        let numberOfInputFields = pollDetails.options?.length || 2;      // either optNum or 2  
        const inputFields = [];
        if (!isEdit) {
            for (let i = 0; i < numberOfInputFields; i++) {
                inputFields.push(inputField(i));
            };
        }
        if (isEdit) {
            pollDetails.options?.map((option, index) => inputFields.push(inputField(index, option)));
        }
        
        return inputFields;
    };

    //--------- USER CHNG DAILY OR CUSTOM then NO OF OPTIONS WILL CHNG --------//
    useEffect(() => {
        const initialPollData = { ...pollDetails };
        let options = [];
        // if(numOpts>=10 && duration==="2"){
        
        if (numOpts >= 1) {
            let i = 0;
            if (isEdit) {
                while (i < numOpts && i < initialPollData?.options?.length) {
                    let opt = {
                        id: initialPollData?.options[i]?.id,
                        option: initialPollData?.options[i]?.option,
                        image: initialPollData?.options[i]?.option_image || initialPollData?.options[i]?.image,
                        order: initialPollData?.options[i]?.order_no  

                    }

                    options.push(opt);
                    i++;
                }
            } else {
                while (i < numOpts && i < initialPollData?.options?.length) {
                    options.push(initialPollData?.options[i]);
                    i++;
                }
            }
            while (i < numOpts) {
                options.push({ option: "", image: null, order: "" });
                i++;
            }
        }
        initialPollData.options = options;
        setPollDetails(initialPollData);
    }, [numOpts]);

    //-- SET pollDetails.options imgs ACCORDING TO IMG API RESPONSE --//
    useEffect(() => {
        if (!pollDetails || !pollOptions) return;
        
        let newArray = new Array(numOpts);
        for (let i = 0; i < numOpts; i++) {
            if (pollOptions[i]?.data) {
                newArray[i] = {
                    option: pollDetails?.options[i]?.option,
                    image: pollOptions[i]?.data,
                    order: pollDetails?.options[i]?.order
                };
                
                if (isEdit) {
                    newArray[i][`id`] = pollDetails?.options[i]?.id
                }
            } else {
                try {

                    //order step
                    
                    newArray[i] = {
                        option: pollDetails?.options[i]?.option || "",
                        image: pollDetails?.options[i]?.option_image || pollDetails?.options[i]?.image || null,
                        order: pollDetails?.options[i]?.order
                    }
                    if (isEdit) {
                        newArray[i][`id`] = pollDetails?.options[i]?.id
                    }
                } catch (error) {
                }
            }
        }
        setPollDetails({
            ...pollDetails, options: [...newArray]
        })
        setEditDetails({
            ...editDetails, options: [...newArray]
        })
    }, [imgSuccess, Object.keys(pollOptions).length]);

    return (
        <div
            style={{
                overflowY: 'scroll',
                height: "800px",
            }}
        >
            {generateInputFields()}
        </div>
    )
}

export default PollOptionsV3;